import { useState } from "react";
import { UserRole } from "../../hooks/useAdminsRequest";
import useApiRequest from "../../helpers/api_request";
import { useAppSelector } from "../../app/hooks";
import useErrorToast from "../../helpers/errorToast";
import { selectAccessToken } from "../../features/auth/authSlice";
import { BASE_URL } from "../../helpers/constants";

const useRolesRequest = () => {
  const [fetchingRoles, setFetchingRoles] = useState(false);
  const [roles, setRoles] = useState<UserRole[]>([]);
  const apiRequest = useApiRequest()
  const errorToast = useErrorToast()
  const accessToken = useAppSelector(selectAccessToken);

  const getRoles = async () => {
    setFetchingRoles(true);
    await apiRequest({
      method: 'get',
      url: BASE_URL + "/api/role/roles",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((response) => {
      setRoles(response.data)
      setFetchingRoles(false)
    }).catch((error) => {
      errorToast(error);
      setFetchingRoles(false)
    });
  }

  return {
    getRoles,
    fetchingRoles,
    roles
  }
}

export default useRolesRequest;
